import axios from 'axios'
// import Cookies from 'js-cookie'


// let instance = axios.create({
//   headers: {
//     'content-type': 'application/json'
//   }
// })

// // http request 拦截器
// instance.interceptors.request.use(
//   config => {
//     if (Cookies.get('JWT')) { // 判断是否存在token，如果存在的话，则每个http header都加上token
//       config.headers.Authorization = `Bearer ${Cookies.get('JWT')}` //请求头加上token
//     }
//     return config
//   },
//   err => {
//     return Promise.reject(err)
// })



export default ({
  url,
  method='GET',
  data,
  params,
  headers = { 'content-type': 'application/json'},
  config
}) => {
  return axios({
    // baseURL: process.env.NODE_ENV === 'production' ? 'https://car.techbrew.cn/' : 'https://car.techbrew.cn/',
    method,
    url,
    data,
    params,
    headers,
    config
  }).then((res) => {
    return res.data
  }).catch(res => {
    return res
  })
}